import Stack from '@eversports/klimt-primitives/legacy/Stack'
import Text from '@eversports/klimt-primitives/legacy/Text'
import * as React from 'react'

import EmptyStar from '../../../../assets/icons/empty-star.svg'
import FilledStar from '../../../../assets/icons/filled-star.svg'
import { Localized } from '../../../../localization/react'

interface Props {
  rating: number | null
  reviewCount: number
}

const Rating: React.FC<React.PropsWithChildren<Props>> = ({ rating, reviewCount }) => {
  return (
    <Stack direction="row" alignItems="center" spacing={2}>
      <img src={reviewCount ? FilledStar : EmptyStar} alt="rating" loading="lazy" width="14px" height="14px" />
      <Text variant="small" sx={{ color: 'darkgray', fontWeight: 'bold' }}>
        {rating ? (
          <Localized id="rating-review-count" params={{ rating: rating.toFixed(2), reviewCount }} />
        ) : (
          <Localized id="rating-no-reviews" />
        )}
      </Text>
    </Stack>
  )
}

export default Rating
